import React from 'react';
import { SkeletonText } from '@shape-construction/arch-ui/src/Skeleton';
import { CrashPage } from 'app/components/CrashPage/CrashPage';

type WidgetProps = {
  title: React.ReactNode;
  actions?: React.ReactNode;
  isLoading?: boolean;
  isError?: boolean;
};

export const Widget: React.FC<React.PropsWithChildren<WidgetProps>> = ({
  title,
  children,
  actions,
  isLoading,
  isError,
}) => {
  const Loading = (
    <div data-testid="widget-loading" className="space-y-2 w-full">
      <SkeletonText animation="pulse" size="sm" />
      <SkeletonText animation="pulse" size="xxs" />
      <SkeletonText animation="pulse" size="xxs" />
      <SkeletonText animation="pulse" size="xxs" />
    </div>
  );

  const renderContent = () => {
    if (isError) return <CrashPage />;
    if (isLoading) return Loading;
    return children;
  };

  return (
    <div className="bg-white flex flex-1 flex-col border border-neutral-subtlest rounded-lg p-4">
      <div className="flex flex-row mb-3 items-center gap-2 justify-between flex-wrap">
        <span className="text-base font-medium leading-6 text-neutral-bold">{title}</span>
        {!isError && !isLoading && actions && <div className="flex flex-row gap-1">{actions}</div>}
      </div>
      {renderContent()}
    </div>
  );
};
